import { Identity } from 'embedded/api/out/Identity';
import { getQueryParameterValue } from '@instinet-analytics/core-lib';
import { getWindowLocation } from 'utils/components/location';
import { environment } from 'environment';

export interface Indigo2GlobalWindowVariables {
    logLevel?: string;
    key?: string;
    jwt?: string;
    jwtUser?: string;
    panelId?: string;
    application?: string;
    /*
     * This is the version of the host application, provided during JWT login
     */
    applicationVersion?: string;
    /*
     * This is the DART version of the current build
     */
    buildVersion?: string;
    machineId?: string;
    hasAllJwtAuthenticationDetails: boolean;
    suppressLoggingStoreActions?: boolean;
    getMachineId?: () => string;
    logState: () => void;
    send: <T>(topic: string, message: T) => Promise<string>;
    publish: <T>(topic: string, message: T) => void;
    subscribe: <T>(
        identity: Identity,
        topic: string,
        listener: (message: T) => void
    ) => Promise<string>;
    unsubscribe: (identity: Identity, topic: string) => Promise<string>;
    errorCode?: string;
    errorDetails?: string;
    showHoldingPageOnLaunch?: boolean;
}

const defaultIndigo2WindowVariables = {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keyedWindow = window as { [key: string]: any };

export function getGlobalWindowVariables(): Indigo2GlobalWindowVariables {
    const indigo2Window = keyedWindow[
        'indigo2'
    ] as Indigo2GlobalWindowVariables;
    const ret = indigo2Window || defaultIndigo2WindowVariables;

    const urlParams = new URLSearchParams(getWindowLocation().search);

    ret.key = ret.key || urlParams.get('_k')!;
    ret.jwt = ret.jwt || urlParams.get('jwt')!;
    ret.application = ret.application || urlParams.get('application')!;
    ret.applicationVersion =
        ret.applicationVersion || urlParams.get('applicationVersion')!;
    ret.machineId = ret.machineId || urlParams.get('machineId')!;
    ret.panelId = ret.panelId || urlParams.get('PanelId') || undefined;

    ret.hasAllJwtAuthenticationDetails = !!ret.jwt && !!ret.application;

    devModeAppendMockData(ret);

    return ret;
}

export function setGlobalWindowVariable(
    delta: Partial<Indigo2GlobalWindowVariables>
) {
    const value = { ...getGlobalWindowVariables(), ...delta };
    keyedWindow['indigo2'] = value;
}

function devModeAppendMockData(vars: Indigo2GlobalWindowVariables) {
    if (!environment.isDevMode) {
        return;
    }

    const errorCode = getQueryParameterValue('MockErrorCode');
    if (errorCode) {
        vars.errorCode = errorCode;
    }

    const errorDetails = getQueryParameterValue('MockErrorDetails');
    if (errorDetails) {
        vars.errorDetails = errorDetails;
    }

    if (!vars.application) {
        vars.application = 'Indigo';
    }
}
